import React from 'react';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

function CustomButton({
  btnText,
  btnStyle,
  clickHandle,
  startIcon,
  endIcon,
  disabled,
}) {
  return (
    <Button
      color='inherit'
      onClick={clickHandle}
      className={btnStyle}
      component='button'
      variant='outlined'
      // size="medium"
      startIcon={startIcon ? startIcon : null}
      endIcon={endIcon ? endIcon : null}
      disabled={disabled}
    >
      <Typography variant='button' color='inherit'>
        {btnText}
      </Typography>
    </Button>
  );
}

export default CustomButton;
